<template>
  <div class="flex items-center gap-4">
    <button
      type="button"
      class="w-full touch-manipulation text-left text-black"
      @click="$emit('onChildClick')"
    >
      {{ selectedAgeText }}
    </button>
    <button
      type="button"
      class="touch-manipulation font-semibold text-black underline"
      @click="$emit('onChildDelete')"
    >
      {{ t('child-select.delete') }}
    </button>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { MAX_INFANT_AGE } from '@entities/passengers-state';
  import { useChildSelectLocales } from '../locales';

  const { t } = useChildSelectLocales();
  const props = defineProps<{
    age: number;
  }>();

  defineEmits<{
    onChildClick: [];
    onChildDelete: [];
  }>();

  const selectedAgeText = computed(() => {
    const ageText =
      props.age === 0
        ? t('child-select.under-one-year')
        : t('child-select.age-count', {
            count: props.age,
          });

    if (props.age <= MAX_INFANT_AGE) {
      return `${t('child-select.infant')}, ${ageText}`;
    }

    return `${t('child-select.child')}, ${ageText}`;
  });
</script>
